module.exports = require('./helpers/bundle-url').getBundleURL('4Zw3I') + "logo-dark.eefe0b7f.svg";